var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('h2',[_vm._v(_vm._s(_vm.item.attributes.libelle))]),_vm._l((_vm.items),function(item){return _c('div',{key:item.id,staticClass:"mt-3"},[_c('StrapiQuestionComponent',{attrs:{"item":item}})],1)})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }